import { isNilOrEmpty } from './ramdaUtils';

// for tests
const getNavigator = () => window._mockNavigator ?? navigator;
const getWindow = () => window._mockWindow ?? window;

export const shouldUsePasskeyCredentials = () => {
  const UA = getNavigator().userAgent;

  const isIOS = UA.match(/iPhone|iPad|iPod/);
  const standalone = getWindow().matchMedia('(display-mode: standalone)').matches;
  const PWA_INSTALLED = !!(standalone || (isIOS && !UA.match(/Safari/)));

  return getWindow().PublicKeyCredential && PWA_INSTALLED;
};

export function generateRandomBuffer(len) {
  len = len || 32;

  const randomBuffer = new Uint8Array(len);
  getWindow().crypto.getRandomValues(randomBuffer);

  return randomBuffer;
}

export const registerPasskeyCredentialsIfNeeded = async (authData, hasUserChanged) => {
  try {
    if (!shouldUsePasskeyCredentials()) {
      return;
    }

    const platformAuthAvailable = await getWindow().PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();

    if (!platformAuthAvailable) {
      return;
    }

    const passkeyCredentialsId = localStorage.getItem('passkeyCredentialsId');

    if (!isNilOrEmpty(passkeyCredentialsId) && !hasUserChanged) {
      return;
    }

    const challenge = generateRandomBuffer();
    const credentials = await getNavigator().credentials.create({
      publicKey: {
        challenge,
        rp: { name: 'IQVIA', id: getWindow().location.hostname },
        user: {
          id: new Uint8Array(16),
          name: authData.actorCodeWithDomain,
          displayName: authData.username,
        },
        pubKeyCredParams: [
          { type: 'public-key', alg: -7 },
          { type: 'public-key', alg: -257 },
        ],
        timeout: 60000,
        authenticatorSelection: {
          authenticatorAttachment: 'platform',
        },
      },
    });

    localStorage.setItem('passkeyCredentialsId', credentials.id);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('createCredentials() error: ', error);
  }
};
